// extracted by mini-css-extract-plugin
module.exports = {"Faq":"styles_Faq__Vvp0l"};